import { render, staticRenderFns } from "./UsageDataTable.vue?vue&type=template&id=a986196a&"
import script from "./UsageDataTable.vue?vue&type=script&lang=js&"
export * from "./UsageDataTable.vue?vue&type=script&lang=js&"
import style0 from "./UsageDataTable.vue?vue&type=style&index=0&id=a986196a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports